import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('valoriza_token'));
  const [loading, setLoading] = useState(true);
  const skipNextFetch = useRef(false);

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      if (skipNextFetch.current) {
        skipNextFetch.current = false;
        return;
      }
      fetchMe();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchMe = async () => {
    try {
      const res = await axios.get(`${API}/auth/me`);
      setUser(res.data);
    } catch {
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    const { access_token } = res.data;
    localStorage.setItem('valoriza_token', access_token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
    // Fetch the full /me to get vacations_enabled, convenio, etc.
    const meRes = await axios.get(`${API}/auth/me`);
    skipNextFetch.current = true;
    setToken(access_token);
    setUser(meRes.data);
    return meRes.data;
  };

  const logout = () => {
    localStorage.removeItem('valoriza_token');
    delete axios.defaults.headers.common['Authorization'];
    setToken(null);
    setUser(null);
  };

  const loginWithToken = async (accessToken) => {
    localStorage.setItem('valoriza_token', accessToken);
    axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    try {
      const res = await axios.get(`${API}/auth/me`);
      skipNextFetch.current = true; // prevent useEffect from calling fetchMe again
      setToken(accessToken);
      setUser(res.data);
      setLoading(false);
      return res.data;
    } catch (e) {
      localStorage.removeItem('valoriza_token');
      delete axios.defaults.headers.common['Authorization'];
      throw e;
    }
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, loginWithToken, logout, fetchMe }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export { API };
